import React from 'react';
import { Modal } from 'react-bootstrap-v5';
import { useHistory } from 'react-router-dom';
import { KTSVG, toAbsoluteUrl } from 'src/_metronic/helpers';

interface InvoiceEntryReminderModalProps {
  show: boolean;
  onHide: () => void;
  orderCount: number;
}

const InvoiceEntryReminderModal: React.FC<InvoiceEntryReminderModalProps> = ({ show, onHide, orderCount }) => {
  const history = useHistory();

  const dismissModal = () => {
    onHide();
  };

  const handleLinkClick = (e: React.MouseEvent) => {
    e.preventDefault();
    dismissModal();
    history.push({
      pathname: '/orders/orders-management/all',
      state: {
        invoiceEntryExpected: 1,
      },
    });
  };

  return (
    <Modal
      className="modal fade"
      id="kt_modal_invoice_entry_reminder"
      data-backdrop="static"
      tabIndex={-1}
      role="dialog"
      show={show}
      aria-hidden="true"
      onHide={dismissModal}
      centered
    >
      <div className="modal-content">
        <div className="modal-header border-0 pb-0 position-relative px-8 pt-6">
          <img alt="Logo" className="logo" style={{ height: '30px' }} src={toAbsoluteUrl('/media/logos/logo-idefix.svg')} />
          <div className="btn btn-icon btn-sm btn-active-light-primary ms-2 position-absolute end-0 top-0 me-4 mt-4" onClick={dismissModal}>
            <KTSVG path="/media/icons/duotone/Navigation/Close.svg" className="svg-icon-2x" />
          </div>
        </div>

        <div className="modal-body text-center pt-5 px-8 pb-8">
          <div className="d-flex align-items-center justify-content-center gap-4 mb-5">
            <h2 className="fw-bold mb-0 fs-3 text-gray-800">Fatura Girişi Bekleniyor!</h2>
          </div>

          <p className="mb-0 fs-5 text-gray-700 lh-lg">
            Değerli iş ortağımız,{' '}
            <a
              href="/orders/orders-management/all"
              className="text-primary fw-bold text-decoration-underline cursor-pointer"
              onClick={handleLinkClick}
            >
              {orderCount} adet siparişinizde
            </a>{' '}
            fatura girişi bekleniyor. Ceza ve puan kaybı yaşamamak için lütfen en kısa sürede fatura girişlerini tamamlayın. İyi çalışmalar dileriz.
          </p>
        </div>
      </div>
    </Modal>
  );
};

export default InvoiceEntryReminderModal;
